import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { DataService } from "./data.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WidgetConfig } from "../../../class/widget-config";
import { GenericUtils } from './../../../utilities/generic-utils';

addMore(Highcharts);

@Component({
  selector: 'widget-dual-column-chart',
  templateUrl: './widget-dual-column-chart.component.html',
  styleUrls: ['./widget-dual-column-chart.component.scss'],
  providers: [DataService]
})
export class WidgetDualColumnChartComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() WIDGETCONFIG: WidgetConfig;
  @Input() CHARTCONFIG;
  highcharts: typeof Highcharts = Highcharts;
  chartOption1 = null;
  chartOption2 = this.genericUtils.deepCopyFunction(HSET.chart2);
  errorMessage = "";
  mockChart = null;
  mockChart2 = null;
  loadingChart = true;
  errorLoadingChart = false;

  constructor(
    private translateService: TranslateService,
    private dataService: DataService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService,
    private genericUtils: GenericUtils
  ) { }

  ngOnChanges(changes: SimpleChanges) {
      this.getData();
  }

  ngOnInit() {
    this.broadcaster.listen("PAGE_WIDGET_DATA").pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.setWidgetData();
    });
  }

  setWidgetData() {
    const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
    if (pageData) {
      pageData.forEach(element => {
        if (element.widget_id === this.WIDGETCONFIG.id) {
          this.setTarget(element.target);
        }
      });
    }
  }

  setTarget(t) {
    if (this.chartOption2) {
      const lastElement = this.chartOption2.series.length - 1;
      this.chartOption2.series[lastElement].data = [];
      for (let i = 0; i < this.chartOption2.series[0].data.length; i++) {
        this.chartOption2.series[lastElement].data.push(t);
      }
    }
  }
  getData() {
    this.loadingChart = true;
    this.errorLoadingChart = false;
    this.mockChart = null;
    this.chartOption1 = null;
    this.errorMessage = "";
    this.chartOption2.series[0].data = [];
    this.dataService.getData(this.WIDGETCONFIG, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {

          this.loadingChart = false;
          if (chartData === null) {
            this.handleError("ERROR_MSG.NO_DATA");
          } else {
            const charts = this.dataService.createChart(chartData, this.CHARTCONFIG);
            this.chartOption1 = charts.chart1;
            this.chartOption2 = charts.chart2;
            this.setWidgetData();
          }
        },
        error => {
          this.loadingChart = false;
          this.handleError("ERROR_MSG.NO_DATA");
        }
      );
  }

  handleError(message) {
    this.errorLoadingChart = true;
    this.errorMessage = message;
    this.mockChart = [{ chart: HSET.chart1, width: 3 }, { chart: HSET.chart2, width: 9 }];

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }



}
